module.exports = __webpack_public_path__ + "img/our-story1.5b00bf0d.jpg";